export var defaultProps = {
    className: '',
    columns: [],
    data: [],
    rowClassName: function () {
        return '';
    },
    showHeader: true,
    scroll: {},
    useFixedHeader: false,
    rowKey: 'key',
    sortDirections: ['descend', 'ascend'],
    childrenColumnName: 'children',
};
